export default __webpack_public_path__ + "static/media/memo-empty-state.dd65a8ff.svg";